import { render, staticRenderFns } from "./MetricsDashboardHeader.vue?vue&type=template&id=6681f4c9"
import script from "./MetricsDashboardHeader.vue?vue&type=script&lang=js"
export * from "./MetricsDashboardHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports